import React, { Children, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';
import { Document, Page } from "react-pdf";
//  import { Document, Page } from "react-pdf/dist/entry.webpack";
import CoursePdf from './CoursePdf';
const Coursecnt = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true,

    })
    const [pdfUrl, setPdfUrl] = useState('')
    const [hasLink, setHasLink] = useState(false)
    const [hasVideo, setHasVideo] = useState(false)
    const [linksList, setLinksList] = useState([])

    const toggleActivity = (e) => {
      e.currentTarget.parentNode.classList.toggle("active")
    }
    const closePdf =(e) =>{
      e.currentTarget.parentNode.classList.remove('active')
    }
    useEffect(() => {        

      base_url.get(`tutorial/${props.match.params.id}`)
            .then(response => {
                console.log(response.data, 'tutorial')
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
                // setTimeout(() => {
                  let C =document.getElementsByClassName('webview')
                  let children = C[0].children
                  let list = []
                  for (var i=0 ; i < children.length ; i++ ){
                    if(children[i]){
                      if(children[i].childNodes[0]){
                        // console.log(children[i].childNodes[0], 'children[i].childNodes[0]')
                        if(children[i].childNodes[0].attributes){
                          // console.log(children[i].childNodes[0].attributes, 'attributes')
                          if(children[i].childNodes[0].attributes.href){
                            setHasLink(true)
                            list.push(children[i].childNodes[0].attributes)
                            // href.value
                            // title.value
                          }else if(children[i].childNodes[0].attributes.controls){
                            setHasVideo(true)
                            document.getElementsByTagName("video")[0].setAttribute("controlsList", "nodownload");
                          }
                        }
                      }
                    }
                  }
                  console.log(list, "list", state,'state')
                  setLinksList(list)
                  // setTimeout(() => {
                  //   console.log(linksList, 'links list')
                    
                  // }, 1000);
                  // children.map((item)=>(console.log(item.innerHTML)))
                  // C[0].map((item)=>{console.log(item)})
                  
                  // setPdfUrl(C[0].childNodes[1].childNodes[0].attributes.href.value)
                // }, 200);
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])
    const openPdf = (e, href, title) =>{
      localStorage.setItem('pdfLink', href)
      localStorage.setItem('pdfTitle', title)
      props.history.push(`/Education/course-content/${props.match.params.id}/pdf`)
    }
    useEffect(() => {
      console.log(linksList, 'links list') 
    }, [linksList])

    return (
        <div className="instructpg main-course">
            <Loader
                active={state.loader} />

            <div className="Header">
                <span className="cat-title">
                    {state.data.page_title}
                        <i
                        className="icon-arrow-down-sign-to-navigate"
                        onClick={() => props.history.goBack()} ></i>
                </span>
            </div>

            <div className="inner-maincourses">
              <div dangerouslySetInnerHTML={{__html: state.data.page_source}}></div>
              {
              (hasLink && linksList.length )
                ?( <div className="pdfs">
                  {
                  linksList.map((item, index)=> (
                    <div className="pdf-item">
                      <button 
                        className="btn pdf-btn" 
                        id={index} 
                        onClick={(e)=>openPdf(e,item.href.value,item.title.value )}
                      >
                        {item.title.value} <i className="icon-arrow-down-sign-to-navigate"></i>
                      </button>
                    </div>
                    )
                  )}

                </div>)
                :<></>
              }

                      
          </div>
        </div>
    );
}

export default withRouter(Coursecnt);